/*
 * ParticipantListFrameContainer.jsx 30.01.18
 *
 * (c) 2018 ergovia GmbH
 */

import {connect} from 'react-redux';
import ParticipantListFrame from '../../components/participants/ParticipantListFrame';
import {changeSort} from '../../actions/actions';

const mapDispatchToProps = {
    onSortChange: changeSort
};

const mapStateToProps = ({sort}) => ({sort});

export default connect(mapStateToProps, mapDispatchToProps)(ParticipantListFrame);



// WEBPACK FOOTER //
// ./src/de/ergovia/containers/participants/ParticipantListFrameContainer.js